import { combineReducers } from "redux";
// Authentication
import Login from "./auth/login/reducer";
import Layout from "./layouts/reducer";


// Pages > Team
import Team from "./team/reducer";

// File Manager

//Jobs
import Jobs from "./job/reducer";
//API Key

const rootReducer = combineReducers({
  // public

  Login,
  Layout,




  Team,


  Jobs,

});

export default rootReducer;
